import { BASE_GAP_MULTIPLIER } from '@components/Grid/constants';
import { FC, PropsWithChildren } from 'react';

interface Props {
  gap?: number;
}

export const Flex: FC<PropsWithChildren<Props>> = ({
  children,
  gap = 1,
  ...rest
}) => {
  const gapVal = gap * BASE_GAP_MULTIPLIER;
  return (
    <div css={{ display: 'flex', gap: gapVal }} {...rest}>
      {children}
    </div>
  );
};
